import { StoreonModule } from 'storeon'
import { Events, State } from '../../interfaces'

export const modalModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    showModal: 'empty',
    props: {},
    showModalCall: false,
    typeAtc: 'DEFAULT',
    infoCall: {
      type: null
    }
  }))
  store.on('modal/toggle', ({}, { modal, ...params }) => ({
    showModal: modal,
    ...params
  }))
  store.on('modal/close', () => ({ showModal: 'empty', props: {} }))

  store.on('modalCall/show', (state, event) => {
    return {
      showModalCall: event
    }
  })
  store.on('modalCall/changeType', (state, event) => ({
    typeAtc: event
  }))
  store.on('modalCall/setInfo', (state, event) => ({
    infoCall: event
  }))
}
